import { Link } from 'react-router-dom';
import type { NewsItem } from '@/mocks/news';
import { formatHeat } from '@/utils/format';

interface NewsRowProps {
  item: NewsItem;
  showDate?: boolean;
  last?: boolean;
}

function NewsRow({ item, showDate = true, last = false }: NewsRowProps) {
  return (
    <article className="relative flex gap-4 md:gap-6">
      <div className="hidden w-20 shrink-0 pt-1 text-right sm:block">
        <div className="font-heading text-sm font-bold text-foreground-950">{item.time}</div>
        {showDate && <div className="mt-0.5 text-xs text-foreground-500">{item.date}</div>}
      </div>

      <div className="relative flex shrink-0 flex-col items-center">
        <span className="mt-1.5 flex h-3 w-3 items-center justify-center rounded-full border-2 border-accent-500 bg-background-50" />
        {!last && <span className="mt-1 w-px flex-1 bg-background-300" />}
      </div>

      <div className={`flex-1 ${last ? 'pb-1' : 'pb-7'}`}>
        <div className="sm:hidden mb-1.5 flex items-center gap-2 text-xs text-foreground-500">
          <span className="font-medium text-foreground-800">{item.time}</span>
          {showDate && <span>{item.date}</span>}
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
            {item.category}
          </span>
          {item.isTop && (
            <span className="rounded-md bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800">
              置顶快讯
            </span>
          )}
        </div>

        <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/topic/${item.topicSlug}`} className="cursor-pointer hover:text-primary-700">
            {item.title}
          </Link>
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>

        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-foreground-600">
          <span className="inline-flex items-center gap-1">
            <i className="ri-newspaper-line" />
            {item.source}
          </span>
          <span className="inline-flex items-center gap-1 text-accent-700">
            <i className="ri-fire-fill" />
            {formatHeat(item.heat)}
          </span>
          <Link
            to={`/topic/${item.topicSlug}`}
            className="inline-flex items-center gap-1 whitespace-nowrap text-primary-700 hover:text-primary-800"
          >
            查看事件脉络
            <i className="ri-arrow-right-s-line" />
          </Link>
        </div>
      </div>
    </article>
  );
}

export default NewsRow;